import { getFrontendFunctionsBaseUrl } from '@src/config';
import type { Post } from '@src/store/contentEntities/model';

export function purgePostCache(post: Post) {
    const baseUrl = getFrontendFunctionsBaseUrl();

    // Purge individual post cache
    if (post.id) fetch(`${baseUrl}/cache?key=post_${post.id}`, { method: 'DELETE' });
    if (post.slugUrl) fetch(`${baseUrl}/cache?key=post_${post.slugUrl}`, { method: 'DELETE' });

    // Purge pinned posts cache based on post kind (partner vs community)
    if (post.isPinned || post.isPinned === false) {
        // Purge global pinned posts cache
        const pinnedCacheKey = post.kind === 'story' ? `pinnedPartnerPosts_${post.tokenName}_all` : `pinnedCommunityPosts_${post.tokenName}_all`;
        fetch(`${baseUrl}/cache?key=${pinnedCacheKey}`, { method: 'DELETE' });

        // Purge flair-specific pinned posts cache if the post has flairs
        if (post.flairIds && post.flairIds.length > 0) {
            post.flairIds.forEach(flairId => {
                const flairPinnedCacheKey = post.kind === 'story' ? `pinnedPartnerPosts_${post.tokenName}_${flairId}` : `pinnedCommunityPosts_${post.tokenName}_${flairId}`;
                fetch(`${baseUrl}/cache?key=${flairPinnedCacheKey}`, { method: 'DELETE' });
            });
        }
    }

    // Purge partner posts list cache if it's a partner post
    if (post.kind === 'story') {
        const flairId = post.flairIds?.[0] || 'all';
        fetch(`${baseUrl}/cache?key=partnerPosts_${post.tokenName}_${flairId}`, { method: 'DELETE' });
    }
}
